import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) return setError("Reset link is missing or invalid.");
    if (pwd.length < 6) return setError("Password must be at least 6 characters.");
    if (pwd !== confirm) return setError("Passwords don't match.");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Password updated. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not reset password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="brand-card p-8 sm:p-10">
          <div className="overline mb-3">Set a new password</div>
          <h1 className="text-3xl font-extrabold text-[#3D405B] tracking-tight">Choose something memorable.</h1>
          <p className="text-sm text-[#7A7D96] mt-2">Use at least 6 characters. After this you'll be asked to sign in again.</p>

          <form onSubmit={onSubmit} className="space-y-4 mt-6">
            <div>
              <label className="block text-xs font-bold text-[#3D405B] uppercase tracking-wider mb-2">New password</label>
              <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} className="w-full px-4 py-3 rounded-2xl bg-white border border-[#3D405B]/15 focus:ring-2 focus:ring-primary/40 focus:border-primary outline-none" data-testid="reset-password-input" />
            </div>
            <div>
              <label className="block text-xs font-bold text-[#3D405B] uppercase tracking-wider mb-2">Confirm password</label>
              <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full px-4 py-3 rounded-2xl bg-white border border-[#3D405B]/15 focus:ring-2 focus:ring-primary/40 focus:border-primary outline-none" data-testid="reset-confirm-input" />
            </div>
            {error && <div className="text-sm text-destructive bg-destructive/10 px-3 py-2 rounded-xl" data-testid="reset-error">{error}</div>}
            <button type="submit" disabled={submitting} className="w-full px-5 py-3 rounded-full bg-primary text-white font-bold shadow-md hover:-translate-y-0.5 hover:shadow-lg transition-all disabled:opacity-60" data-testid="reset-submit-btn">
              {submitting ? "Updating…" : "Update password"}
            </button>
          </form>

          <p className="text-sm text-center text-[#7A7D96] mt-6">
            <Link to="/login" className="text-primary font-bold hover:underline">Back to sign in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
